"use client";
import CurrentStatusSection from '@/components/About/currentstatus';
import HeroSection from '@/components/About/HeroSection';
import MissionVision from '@/components/About/MissionVision';
import OurStory from '@/components/About/OurStory';
import WhatWeDo from '@/components/About/WhatWeDo';
import TestimonialSection from '@/components/Common/TestimonialSection';
import Leadership from '@/components/Leadership';
import OrgChartPage from '@/components/Orgchartpage/orgchartpage';
import { motion } from 'framer-motion';
import dynamic from 'next/dynamic';
import { useEffect, useState } from 'react';

// Clean color palette - Only Deep Teal Green and White
const colors = {
  primary: "#395750",      // Deep Teal Green - Company color
  primaryDark: "#2A423C",  // Darker teal
  primaryLight: "#4B6B63", // Lighter teal
  white: "#FFFFFF",        // White
  whiteOff: "#F8F9FA",     // Off-white for subtle contrast
  textDark: "#1A2E29",     // Dark text for contrast
};

const AboutPage = () => {
  return (
    <>
      <HeroSection />
      <MissionVision />
      <WhatWeDo />
      <OurStory />
      <Leadership />
      <OrgChartPage />

      {/* Contact CTA */}
      <div 
        className="py-20"
        style={{
          background: `linear-gradient(135deg, ${colors.primary}, ${colors.primaryDark})`
        }}
      >
        <div className="container mx-auto px-4 text-center">
          <h2 className="mb-6 text-3xl font-bold sm:text-4xl" style={{ color: colors.white }}>
            Need Help Finding Us?
          </h2>
          <p className="mx-auto mb-10 max-w-2xl text-lg" style={{ color: `${colors.white}E6` }}>
            Our customer service team is ready to assist you with directions or any inquiries.
          </p>
          <div className="flex flex-col justify-center gap-4 sm:flex-row">
            <motion.a
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              href="/branches"
              className="rounded-lg px-8 py-3 font-medium shadow-lg transition-all duration-300 hover:shadow-xl"
              style={{ 
                backgroundColor: colors.white,
                color: colors.primary
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = colors.primaryLight;
                e.currentTarget.style.color = colors.white;
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = colors.white;
                e.currentTarget.style.color = colors.primary;
              }}
            >
              More About
            </motion.a>
            <motion.a
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              href="/contact"
              className="rounded-lg border-2 px-8 py-3 font-medium transition-all duration-300"
              style={{ 
                borderColor: colors.white,
                color: colors.white,
                backgroundColor: 'transparent'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = colors.white;
                e.currentTarget.style.color = colors.primary;
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = 'transparent';
                e.currentTarget.style.color = colors.white;
              }}
            >
              Email Us
            </motion.a>
          </div>
        </div>
      </div>
    </>
  );
};

export default AboutPage;